import actionTypes from '../actionTypes';

const initialState = {
  isAuthenticated: false,
  status: null,
  email: null,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.AUTH_LOGOUT:
      return {
        ...initialState,
      };

    case actionTypes.INVALID_TOKEN:
    case actionTypes.AUTH_VERIFY_EMAIL_REQUEST:
      return {
        ...state,
        status: action.type,
      };

    case actionTypes.AUTH_LOGIN_REQUEST:
    case actionTypes.AUTH_SIGNUP_REQUEST:
    case actionTypes.AUTH_FORGOT_REQUEST:
    case actionTypes.AUTH_FORGOT_SUCCESS:
    case actionTypes.AUTH_RESET_REQUEST:
    case actionTypes.AUTH_RESET_SUCCESS:
    case actionTypes.AUTH_SIGNUP_SUCCESS:
    case actionTypes.AUTH_CONFIRM_EMAIL_REQUEST:
    case actionTypes.AUTH_VERIFY_EMAIL_SUCCESS:
    case actionTypes.RESEND_CONFIRMATION_LINK_REQUEST:
    case actionTypes.RESEND_CONFIRMATION_LINK_SUCCESS:
      return {
        ...initialState,
        status: action.type,
      };

    case actionTypes.AUTH_LOGIN_ERROR:
    case actionTypes.AUTH_SIGNUP_ERROR:
    case actionTypes.AUTH_FORGOT_ERROR:
    case actionTypes.AUTH_RESET_ERROR:
    case actionTypes.AUTH_EMAIL_ERROR:
    case actionTypes.AUTH_CONFIRM_EMAIL_ERROR:
    case actionTypes.RESEND_CONFIRMATION_LINK_ERROR:
      return {
        ...initialState,
        status: action.type,
        error: action.error,
      };

    case actionTypes.SET_LOGGED_IN:
    case actionTypes.AUTH_LOGIN_SUCCESS:
      return {
        ...initialState,
        status: action.type,
        isAuthenticated: true,
      };

    case actionTypes.AUTH_EMAIL_SUCCESS:
    case actionTypes.AUTH_CONFIRM_EMAIL_SUCCESS:
      return {
        ...initialState,
        status: action.type,
        email: action.email,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// src/redux/reducers/auth.js